import withMatcher from '#/utils/withMatcher';
import { IAlbums, ITrack } from '../reducers/artistAlbums';
import { IArtistAlbums as IArtistAlbumsResponse } from '#/types/API/artists';

export const createActionAlbumSetAlbum = withMatcher((payload: IAlbums) => {
  return {
    type: 'album/set_album',
    payload,
  };
});

export const createActionAlbumSetOtherAlbums = withMatcher(
  (payload: IArtistAlbumsResponse['items']) => {
    return {
      type: 'album/set_other_albums',
      payload,
    };
  }
);

export const createActionAlbumStartLoading = withMatcher(() => {
  return {
    type: 'album/start_loading',
  };
});

export const createActionAlbumStopLoading = withMatcher(() => {
  return {
    type: 'album/stop_loading',
  };
});

export const createActionAlbumSetErrorDetails = withMatcher(
  (error: boolean) => {
    return {
      type: 'album/set_error',
      payload: error,
    };
  }
);

export const createActionAlbumSetIsFollowed = withMatcher(
  (payload: { follow: boolean }) => {
    return {
      type: 'album/set_album_is_followed',
      payload,
    };
  }
);

export const createActionAlbumSetTrackIsFollowed = withMatcher(
  (payload: { track: string; follow: boolean }) => {
    return {
      type: 'album/set_track_is_followed',
      payload,
    };
  }
);

export const createActionAlbumSetTracks = withMatcher(
  (payload: { tracks: ITrack }) => {
    return {
      type: 'album/set_tracks',
      payload,
    };
  }
);

export const createActionAlbumReset = withMatcher(() => {
  return {
    type: 'album/reset',
  };
});
